import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Result } from '../../../shared/result';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgencyMasterService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };

constructor(private http: HttpClient) {
}

public GetAgencyTypeMaster() {

  return this.http.post<Result>(`${environment.apiUrl}/Agency/GetAgencyTypeMaster`,null, this.httpOptions);
  }

public GetAgencyMaster(data:any) {

return this.http.post<Result>(`${environment.apiUrl}/Agency/GetAgencyMaster`,data, this.httpOptions);
}

public InsertandUpdateAgencyMaster(data: any) {
return this.http.post<Result>(environment.apiUrl + `/Agency/InsertandUpdateAgencyMaster`, data, this.httpOptions);
}

public DeleteAgencyMaster(data: any) {
return this.http.post<Result>(environment.apiUrl + `/Agency/DeleteAgencyMaster`, data, this.httpOptions);
}

public InsertAgencyTopupData(data: any) {
  return this.http.post<Result>(environment.apiUrl + `/CreditBalance/InsertAgencyTopupData`, data, this.httpOptions);
  }

public GetTransactionDetailsByAgencyID(data:any){
  return this.http.post<Result>(environment.apiUrl+`/Agency/GetTransactionDetailsByAgencyID`,data,this.httpOptions);
}
  public InsertAgencyWiseTicketPages(data: any) {
    return this.http.post<Result>(environment.apiUrl + `/CreditBalance/InsertAgencyWiseTicketPages`, data, this.httpOptions);
    }

public GetAgencyPaymentModeMaster(){
     return this.http.post<Result>(`${environment.apiUrl}/Common/GetAgencyPaymentModeMaster`,null);           
   }
}
